module.exports = __webpack_public_path__ + "static/media/left-arrow-table.89db5d68.svg";